import { clsx } from 'clsx'
import type { ReactNode } from 'react'

export const inputClass =
  'w-full h-12 px-[17.5px] rounded-qb-md border border-[#e5e5e5] border-[1.5px] bg-white text-[18px] font-normal text-qb-text-high placeholder:text-qb-text-low tracking-[-0.6px] focus:outline-none focus:border-qb-primary transition-colors'

export function Field({
  label,
  error,
  children,
}: {
  label: string
  error?: string
  children: ReactNode
}) {
  return (
    <div className="flex flex-col gap-2">
      <label className="text-[18px] font-semibold text-qb-text-high tracking-[-0.6px] leading-[1.5]">
        {label}
      </label>
      {children}
      {error && (
        <span className="text-qb-body-4 text-qb-negative" role="alert">
          {error}
        </span>
      )}
    </div>
  )
}

export function CheckCircle({ checked }: { checked: boolean }) {
  return (
    <span
      className={clsx(
        'inline-flex items-center justify-center w-6 h-6 rounded-full shrink-0 transition-colors',
        checked ? 'bg-qb-primary' : 'bg-[#dadada]',
      )}
      aria-hidden
    >
      <svg width="12" height="9" viewBox="0 0 12 9" fill="none">
        <path
          d="M1 4L4.5 7.5L11 1"
          stroke="white"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  )
}

export function ChevronIcon() {
  return (
    <span className="pointer-events-none absolute right-[10.5px] top-1/2 -translate-y-1/2 w-6 h-6 flex items-center justify-center text-qb-text-low">
      <svg width="12" height="8" viewBox="0 0 12 8" fill="none">
        <path
          d="M1 1L6 6L11 1"
          stroke="#a0a0a0"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  )
}
